import { useEffect, useMemo, useState } from 'react';
import { X } from 'lucide-react';
import communityAPI from '../../api/community';
import { sanitizeRichText } from '../../utils/sanitizeHtml';

export default function LegalDocumentModal({ type, isOpen, onClose }) {
  const [document, setDocument] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (isOpen && type) {
      setLoading(true);
      communityAPI.legal.getCurrent(type)
        .then(res => setDocument(res.data))
        .catch(() => setDocument(null))
        .finally(() => setLoading(false));
    }
  }, [isOpen, type]);

  const sanitizedContent = useMemo(
    () => sanitizeRichText(document?.content || ''),
    [document?.content]
  );

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4">
      <div className="relative max-h-[90vh] w-full max-w-3xl overflow-hidden rounded-2xl bg-white shadow-2xl dark:bg-[#161616]">
        <div className="sticky top-0 flex items-center justify-between border-b border-gray-200 bg-white px-6 py-4 dark:border-gray-800 dark:bg-[#161616]">
          <h2 className="blog-title text-2xl font-bold text-gray-950 dark:text-white">
            {loading ? 'Loading...' : document?.title || (type === 'terms' ? 'Terms of Service' : 'Privacy Policy')}
          </h2>
          <button onClick={onClose} className="rounded-lg p-2 hover:bg-gray-100 dark:hover:bg-[#0E0E0E]">
            <X size={20} className="text-gray-500 dark:text-gray-400" />
          </button>
        </div>
        <div className="overflow-y-auto p-6" style={{ maxHeight: 'calc(90vh - 80px)' }}>
          {loading ? (
            <p className="text-gray-500 dark:text-gray-400">Loading document...</p>
          ) : document ? (
            <div className="prose prose-sm max-w-none dark:prose-invert" dangerouslySetInnerHTML={{ __html: sanitizedContent }} />
          ) : (
            <p className="text-gray-500 dark:text-gray-400">Document not available.</p>
          )}
        </div>
      </div>
    </div>
  );
}
